import { render } from "./HealthHistory.vue?vue&type=template&id=9d1c72e8&ts=true"
import script from "./HealthHistory.ts?vue&type=script&lang=ts&external"
export * from "./HealthHistory.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__